export const CHECK_DELAY = 33;

export const LOAD_MORE_DELAY = 1500;
